export default __webpack_public_path__ + "static/media/28_4_2.83f37dec.png";